import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var FolderIconSvg = function FolderIconSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AA8226",
    fillRule: "evenodd",
    d: "M19.005 22C20.107 22 21 21.11 21 20V7a2 2 0 0 0-2-2h-7.493c-.556 0-1.08-.443-1.17-.982l-.01-.05C10.148 2.88 9.114 2 8 2H2a2 2 0 0 0-2 1.99v16.02C0 21.108.902 22 1.995 22z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE385",
    fillRule: "evenodd",
    d: "M.392 20.039C.175 21.122.902 22 1.994 22h17.011c1.102 0 2.169-.871 2.387-1.961l2.215-11.078C23.824 7.878 23.097 7 22.005 7H4.995c-1.102 0-2.17.871-2.388 1.961z",
    clipRule: "evenodd"
  }));
};
export var FolderIcon = function FolderIcon(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: FolderIconSvg
  }));
};